<template>
  <DsModal
    :open="dialog"
    :title="title"
    :text="text"
    :primary-button-label="primaryButtonLabel"
    :secondary-button-label="secondaryButtonLabel"
    :width="'600px'"
    @secondary="cancelAction()"
    @primary="confirmAction()"
  />
</template>

<script>
import { mapActions } from 'vuex';
import formModal from '@/mixins/form-modal';
import { DsModal } from '@ds/components';

export default {
  name: 'DeleteUniverseModal',
  components: {
    DsModal,
  },
  mixins: [
    formModal,
  ],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    dashboard: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: this.$t('DeleteUniverseModal.label.title.modal'),
      text: this.$t('DeleteUniverseModal.text.modalTextBody'),
      primaryButtonLabel: this.$t('DeleteUniverseModal.label.button.primaryButtonLabel'),
      secondaryButtonLabel: this.$t('DeleteUniverseModal.label.button.secondaryButtonLabel'),
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
    }
  },
  methods: {
    ...mapActions('dashboard', [
      'deleteDashboard',
    ]),
    cancelAction() {
      this.$emit('close-delete-modal');
    },
    async confirmAction() {
      try {
        await this.deleteDashboard({ ...this.user, ...this.dashboard });
        this.$emit('close-delete-modal-and-reload');
      } catch (err) {
        console.error('error result: ', err);
      }
    },
  }
};
</script>
